import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useCompleteSignOut } from "@/hooks/useCompleteSignOut";
import { configureUnauthorizedHandler } from "@/lib/auth/unauthorizedHandler";

/**
 * App wiring: connect queryClient 401s to toast + completeSignOut.
 * Mount once under the router (needs navigate / i18n).
 */
export function UnauthorizedSessionBridge() {
  const { t } = useTranslation("toasts");
  const completeSignOut = useCompleteSignOut();

  useEffect(() => {
    configureUnauthorizedHandler(async () => {
      toast.error(t("sessionExpired"), {
        toastId: "sessionExpiredToast",
        autoClose: 5000,
        position: "top-center",
      });
      await completeSignOut();
    });

    return () => configureUnauthorizedHandler(null);
  }, [completeSignOut, t]);

  return null;
}
